export enum AccountErrorCodes {
  ACCOUNT_NICKNAME_UPDATE_FAILED = 'account_nickname_update_failed',
  ACCOUNT_ALREADY_CLOSED = 'account_already_closed',
  ACCOUNT_ZERO_BALANCE = 'account_zero_balance',
  ACCOUNT_CLOSED_ERROR = 'account_closed_error',
  ACCOUNT_CLOSE_COMPLIANCE_ERROR = 'account_close_compliance_error',
  AMOUNT_NOT_VALID = 'amount_not_valid',
  MAX_DEPOSIT_LIMIT = 'max_deposit_limit',
  APPLICANT_CHECK_FAILED = 'applicant_check_failed',
  MATURITY_DECISION_FAILED = 'maturity_decision_failed',
  STATEMENT_INVALID_DATE_FUTURE = 'statement_invalid_date_future',
  ACCOUNT_NICKNAME_MAX_LENGTH = 'account_nickname_max_length',
  DEPOSIT_VALIDATION_FAILED = 'deposit_validation_failed',
  INSTITUTION_ACTION_NOT_SUPPORTED = 'institution_action_not_supported',
  NOMINATED_BANK_ACCOUNT_UPDATE_FAILED = 'nominated_bank_account_update_failed',
  COP_CHECK_VERIFICATION_EXPIRED = 'cop_verification_expired',
  NOMINATED_ACCOUNT_MISMATCH = 'nominated_account_mismatch',
  FIXED_TERM_ACCOUNT_FUNDED = 'fixed_term_account_funded',
  NOMINATED_ACCOUNT_REQUIRED = 'nominated_account_required',
  ACCOUNT_PAYEE_NOT_FOUND = 'account_payee_not_found',
}
